import { Button, DraggableWindowHeader } from "@hoylu/client-common";
import React, { type CSSProperties } from "react";
import { useI18n } from "../../../utils/hooks/use.i18n";
import { Modal } from "../Modal";
import Styles from "./ErrorDialogWithImage.module.css";

export type ErrorDialogWithImageProps = {
  imageUrl: string;
  title: string;
  text?: string;
  buttonText?: string;
  showButton?: boolean;
  showExternalLinkSymbol?: boolean;
  onButtonClick?: () => any;
  onCancel?: () => any;
  buttonCustomStyles?: CSSProperties;
};

export const ErrorDialogWithImage: React.FC<ErrorDialogWithImageProps> = ({
  onCancel,
  onButtonClick,
  title,
  text,
  buttonText,
  imageUrl,
  showButton = true,
  showExternalLinkSymbol = false,
  buttonCustomStyles,
}) => {
  const tClose = useI18n("CLOSE_BUTTON.");

  return (
    <Modal handleOutsideClick={onCancel}>
      <DraggableWindowHeader
        close={tClose("CLOSE")}
        onClose={() => onCancel?.()}
        title=""
      />
      <div className={Styles.errorDialogWithImage}>
        <img alt="headerGraphic" className={Styles.image} src={imageUrl} />
        <div className={Styles.header}>{title}</div>
        {text && <p className={Styles.description}>{text}</p>}
        {buttonText && showButton && (
          <Button
            additionalStyles={buttonCustomStyles}
            onClick={() => onButtonClick?.()}
            type="attention"
          >
            {buttonText}
            {showExternalLinkSymbol && (
              <span
                className={`hoylu-ui-icons-link-from-task ${Styles.linkIcon}`}
              />
            )}
          </Button>
        )}
      </div>
    </Modal>
  );
};
